import { _enableDeviceLostRecovery } from './device-lost-recovery.js';
import { _releaseDeviceLostRecoveryCapture, _retainDeviceLostRecoveryCapture } from './device-lost-recovery-capture.js';

function enableDeviceLostSceneRecovery(engine, options = {}) {
  return _enableDeviceLostRecovery(engine, {
    _kind: "scene",
    _recoverOrder: 100,
    _enable(currentEngine) {
      _retainDeviceLostRecoveryCapture(currentEngine, true);
    },
    _disable(currentEngine) {
      _releaseDeviceLostRecoveryCapture(currentEngine, true);
    },
    async _recover(currentEngine) {
      const { rebuildRegisteredScenes } = await import('./recovery-rebuild.js');
      await rebuildRegisteredScenes(currentEngine);
    },
    _onLost: options.onLost,
    _onRecovered: options.onRecovered,
    _onRecoveryFailed: options.onRecoveryFailed
  });
}

export { enableDeviceLostSceneRecovery };
//# sourceMappingURL=device-lost-scene-recovery.js.map
